import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { takeUntil } from 'rxjs/operators';
import { GroupModel } from '../models/groups.model';
import { GroupsService } from '../../../../../services/groups.service';
import { LayoutsService } from '../../../../../services/layouts.service';
import { CustomersService } from '../../../../../services/customers.service';


@Component({
	selector: 'app-edit-create-groups',
	templateUrl: './edit-create-groups.component.html',
	styleUrls: ['./edit-create-groups.component.scss']
})
export class EditCreateGroupsComponent implements OnInit, OnDestroy {

	@Input() data: any = {};
	formGroup: RxFormGroup;

	fields: any = {
		name: {
			type: 'input',
			options: {
				path: 'name',
				class: 'col-sm-12',
				label: {
					text: 'Nombre',
					class: 'col-sm-12'
				}
			}
		},
		client_id: {
		type: 'select',
		options: {
			path: 'client_id',
			label: {
				text: 'Cliente'
			},
			dropdown: {
				text: 'Seleccione...',
				options: []
			}
		}
		},
		active: {
			type: 'switch',
			options: {
				path: 'active',
				label: {
					text: '¿Activo?'
				},
				switchers: {
					trueCaption: 'Si',
					falseCaption: 'No'
				}
			}
		},
		number_layouts: {
			type: 'radio_button',
			options: {
				path: 'number_layouts',
				label: {
					text: 'Numero de Layouts'
				},
				dropdown: {
					text: 'Seleccione...',
					options: [
						1,
						2
					]
				}
			}
		},
		layout_one: {
			type: 'select',
			options: {
				path: 'layout_one',
				label: {
					text: 'Layout Pantalla Principal'
				},
				dropdown: {
					text: 'Seleccione...',
					options: [

					]
				}
			}
		},
		layout_two: {
			type: 'select',
			options: {
				path: 'layout_two',
				label: {
					text: 'Layout Segunda Pantalla'
				},
				dropdown: {
					text: 'Seleccione...',
					options: [

					]
				}
			}
		}
	};
	isAdmin: boolean = false;

	private atComponentDestroy = new Subject();

	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private groupsService: GroupsService,
		private layoutsService: LayoutsService,
		private customersService: CustomersService
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.formGroup = data;
			});
	}
	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		this.isAdmin = this.data?.is_admin || false;
		await this.formService.transformIntoFormGroup(GroupModel, this.data);
		let layouts = await this.layoutsService.getAll();
		layouts = layouts.map(data => ({ id: data.id, name: data.name }));

		this.fields.layout_one.options.dropdown.options = [...layouts];
		this.fields.layout_two.options.dropdown.options = [...layouts];

		if (!this.data?.id) {
			this.formGroup.get('number_layouts').setValue(1);
		} else {
			this.formGroup.get('number_layouts').setValue(this.data.number_layouts);

			if (this.data.layouts.length) {
				this.formGroup.get('layout_one').setValue(this.data.layouts[0].id);

				if (this.data.number_layouts === 2) {
					this.formGroup.get('layout_two').setValue(this.data.layouts[1]?.id);
				}
			}
		}
				if (this.fields.client_id) {
		try {
			const clientsResponse = await this.customersService.getAll();
			const clients = (clientsResponse.data ?? []).map(client => ({
			id: client.id,
			name: client.name
			}));
			this.fields.client_id.options.dropdown.options = [...clients];
		} catch (e) {
			console.error("Error al cargar clientes", e);
		}
		}
		this.formGroup.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.cdr.markForCheck();
			});
	}

	/**
	 * Send the data to the server
	 */
	submit(): void {
		this.groupsService.createOrUpdate(this.formGroup, this.data?.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				data => {
					this.broadcast.reloadDataTable();
					this.modalRef.hide();
				}
			);
	}

	/**
	 * Helper function to transfor an Object to an Array
	 * @param enumme
	 * @returns
	 */
	toArray(enumme): any[] {
		return Object.keys(enumme)
			.map(key => ({ id: key, name: enumme[key] }));
	}

}
